import { Agent, AgentInfo } from "../../schema/types/agent/entity";
import { differenceInSeconds } from "date-fns";
import { dateString } from "../../components/dateStringFn";
import { formatStrings } from "../../utils/time";
import jsYaml from "js-yaml";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";
import { maxBy } from "lodash";

export const AGENT_CHECKING = "Checking";

export const agentHelpers = {
  getEnvText(_: Agent, info?: AgentInfo[]) {
    if (!info) {
      return "Env not found";
    }

    return jsYaml.dump(info, { indent: 2, noRefs: true });
  },
  getLastActiveText(_: Agent, infoArray?: AgentInfo[]) {
    if (!infoArray) {
      return "Checking";
    }

    const lastActive = maxBy(infoArray, (x) => x.lastActive)?.lastActive;

    if (lastActive !== undefined && lastActive !== AGENT_CHECKING) {
      return dateString(lastActive, { format: formatStrings.humanizeWAgo });
    } else {
      return "This agent was never active";
    }
  },
  getIsActive(_: Agent, infoArray?: AgentInfo[]) {
    if (!infoArray) {
      return false;
    }

    const lastActive = maxBy(infoArray, (x) => x.lastActive)?.lastActive;

    if (lastActive !== undefined && lastActive !== AGENT_CHECKING) {
      const nowDate = new Date();
      const lastActiveDate = new Date(lastActive);
      const diff = differenceInSeconds(nowDate, lastActiveDate);
      return diff <= 60;
    } else {
      return false;
    }
  },
};

export interface AgentTableItem extends Agent {
  selfLink: string;
  isActive: boolean;
  lastActiveText: string;
}

interface GetAgentTableItemProps {
  link?: string;
  name?: string;
  item?: Agent;
  info?: AgentInfo[];
}
export function getAgentTableItem({ link, name, item, info: infoArray }: GetAgentTableItemProps): AgentTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;
    const isActive = agentHelpers.getIsActive(item, infoArray);
    const lastActiveText = agentHelpers.getLastActiveText(item, infoArray);

    return {
      ...item,
      selfLink: selfLink,
      isActive: isActive,
      lastActiveText: lastActiveText,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "agent",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      isActive: false,
      lastActiveText: "",
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "agent",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    isActive: false,
    lastActiveText: "",
    lastModified: "",
    tags: {},
    version: 1,
  };
}
